<template>
  <div class="extend-select">
    <a-select
      v-model:value="selectValue"
      :options="options"
      :show-search="showSearch"
      :field-names="fieldNames"
      :option-filter-prop="filterField"
      :placeholder="placeholder"
      :max-tag-count="maxTagCount"
      :tokenSeparators="tokenSeparators"
      :mode="mode"
      :style="style"
      @change="onSelectChange"
      :disabled="disabled"
      :searchValue="currentSearchWord"
      @search="(e:any)=>(currentSearchWord = e)"
    >
      <template #dropdownRender="{ menuNode }">
        <slot name="option">
          <select-option-nodes :vnodes="menuNode" />
        </slot>
        <a-divider style="margin: 4px 0" />
        <div class="extend-wrapper" @mousedown="(e) => e.preventDefault()">
          <div class="check-wrapper">
            <a-button type="link" size="small" @click="onCheckAll">
              全选
            </a-button>
            <a-button type="link" size="small" @Click="onUnCheck">
              反选
            </a-button>
          </div>
          <a-button type="link" size="small" @click="onClearSelected"
            >清空</a-button
          >
        </div>
      </template>
    </a-select>
  </div>
</template>

<script lang="ts" setup>
import { defineComponent, computed, type PropType, ref } from "vue";
import { Select as ASelect, Divider as ADivider } from "ant-design-vue";
import type { SelectOptionsItem } from "@/types";

const SelectOptionNodes = defineComponent({
  props: {
    vnodes: {
      type: Object,
      required: true
    }
  },
  render() {
    return this.vnodes;
  }
});

const props = defineProps({
  options: {
    type: Array as PropType<SelectOptionsItem[]>,
    default: () => []
  },
  value: {
    type: Array as PropType<string[]>,
    default: () => []
  },
  mode: {
    type: String,
    default: "multiple"
  },
  showSearch: {
    type: Boolean,
    default: true
  },
  fieldNames: {
    type: Object,
    default: () => ({ label: "text" })
  },
  filterField: {
    type: String,
    default: "text"
  },
  placeholder: {
    type: String,
    default: ""
  },
  maxTagCount: {
    type: Number,
    default: 10
  },
  tokenSeparators: {
    type: Array as PropType<string[]>,
    default: () => []
  },
  style: {
    type: String
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(["update:value", "change"]);
const selectValue = computed({
  get: () => props.value,
  set: (v) => emit("update:value", v)
});
const currentSearchWord = ref<string>("");
const searchResultList = computed(() => {
  if (currentSearchWord.value) {
    return props.options.filter((item) =>
      item[props.filterField]
        .toLowerCase()
        .includes(currentSearchWord.value.toLowerCase())
    );
  } else return props.options;
});

const onSelectChange = (value: string[], option: SelectOptionsItem[]) => {
  emit("change", value, option);
};

const onClearSelected = () => {
  selectValue.value = [];
};

const onCheckAll = () => {
  let result = [] as any[];
  result = searchResultList.value.map((item) => item.value);
  selectValue.value = result;
};

const onUnCheck = () => {
  let result = [];
  let cancelValues = searchResultList.value
    .filter((item) => selectValue.value.includes(item.value as any))
    .map((item) => item.value);
  let newValues = searchResultList.value
    .filter((item) => !selectValue.value.includes(item.value as any))
    .map((item) => item.value);
  result = selectValue.value.filter(
    (item) => cancelValues.indexOf(item as any) == -1
  );
  result = result.concat(newValues as any);
  selectValue.value = result;
};
</script>

<script lang="ts">
export default {
  name: "check-all-select"
};
</script>

<style lang="less" scoped>
.extend-wrapper {
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  .check-wrapper {
    flex: 1;
    display: inline-flex;
    gap: 8px;
  }
}
</style>
